
import { Component, Emit, Vue } from 'nuxt-property-decorator'
import BaseToolbarElement from './BaseToolbarElement.vue'
import { IToolBarElement } from '../../../shared/general/interfaces/IToolbarElement'

@Component({
  name: 'BaseToolbar',
  components: { BaseToolbarElement },
})
export default class BaseToolbar extends Vue {
  private get fixedItems () : IToolBarElement[] {
    return this.$store.state.ToolbarElements.fixedElements
  }

  private get items () : IToolBarElement[] {
    return this.$store.state.ToolbarElements.elements
  }

  private get sidebarOpen () : boolean {
    return !!this.$store.state.Sidebar.open
  }

  public reset () : void {
    this.$children.forEach((child) => (child as BaseToolbarElement).reset())
  }

  @Emit('click')
  private click () : boolean {
    return true
  }

  destroyed () {
    this.$store.commit('ToolbarElements/reset')
    window.dispatchEvent(new CustomEvent('toolbar-unmounted'))
  }
}
